import React from 'react';

/**
 * 툴바용 구분선 컴포넌트
 */
const ToolbarSeparator = ({ className = '' }) => (
  <div className={`border-l border-gray-300 mx-2 h-6 ${className}`} />
);

export default ToolbarSeparator;
